import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-between align-center" }
const _hoisted_2 = {
  key: 1,
  class: "my-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_title, { value: "Usage Fee Detail" }),
      (_ctx.invoiceDetail && _ctx.invoiceDetail.child)
        ? (_openBlock(), _createBlock(_component_v_chip, {
            key: 0,
            class: "ml-4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`${_ctx.invoiceDetail.child.lastName} ${_ctx.invoiceDetail.child.firstName}`), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        onClick: _ctx.downloadCsv,
        disabled: _ctx.isLoading,
        color: "primary",
        variant: "outlined",
        class: "mr-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("mdi-tray-arrow-down", -1)
            ]))]),
            _: 1
          }),
          _cache[1] || (_cache[1] = _createTextVNode(" CSV Download ", -1))
        ]),
        _: 1
      }, 8, ["onClick", "disabled"]),
      _createVNode(_component_v_btn, {
        onClick: _ctx.downloadInvoice,
        disabled: _ctx.isLoading || _ctx.invoiceStatus != 'invoiceSettled',
        color: "primary",
        variant: "outlined",
        class: "mr-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("mdi-tray-arrow-down", -1)
            ]))]),
            _: 1
          }),
          _cache[3] || (_cache[3] = _createTextVNode(" Invoice Download ", -1))
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          color: "primary"
        }))
      : _createCommentVNode("", true),
    (_ctx.invoiceDetail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_table, { "fixed-header": "" }, {
            default: _withCtx(() => [
              _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Date"),
                  _createElementVNode("th", null, "Arrival Time"),
                  _createElementVNode("th", null, "Departure Time"),
                  _createElementVNode("th", null, "Extended Time (min)"),
                  _createElementVNode("th", null, "Extended Fee"),
                  _createElementVNode("th")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceDetail.nurseryHours, (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", null, _toDisplayString(item.date), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.convertMinuteToHourMinute(item.attendedMin as number)), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.convertMinuteToHourMinute(item.leftMin as number)), 1),
                    _createElementVNode("td", null, _toDisplayString(item.additionalMinutes), 1),
                    _createElementVNode("td", null, _toDisplayString(item.additionalFee != null || item.additionalFee != undefined
                    ? ((item.additionalMinutes == null && _ctx.invoiceDetail.child.hoursPattern && _ctx.invoiceDetail.child.hoursPattern.category == 'monthly') ? `Monthly` : `${item.additionalFee} yen`)
                    : ""), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_btn, {
                        onClick: ($event: any) => (_ctx.updateAttendance(item.date)),
                        color: "primary",
                        variant: "flat",
                        small: "",
                        rounded: ""
                      }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode("Edit Record", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}